import * as React from 'react';
import { Radio as MuiRadio, RadioProps as MuiRadioProps } from '@mui/material';
import { radioCheckedIcon, radioUncheckedIcon, FaOptionIcon } from '@europrocurement/l2d-icons';
import { useTheme } from '@mui/system';

export type RadioProps = MuiRadioProps;

export const Radio: React.FunctionComponent<RadioProps> = function ({
    color = 'primary',
    ...props
}) {
    const { palette } = useTheme();

    const mainColor = palette[color] || palette.primary;

    const icon = (
        <FaOptionIcon
            {...radioUncheckedIcon.props}
            color={palette.background.dark}
            optionProps={{
                style: {
                    ...radioUncheckedIcon?.props?.optionProps?.style,
                    color: palette.grey[400],
                },
            }}
        />
    );
    const checkedIcon = (
        <FaOptionIcon
            {...radioCheckedIcon.props}
            color={mainColor.light}
            optionProps={{
                style: {
                    ...radioCheckedIcon?.props?.optionProps?.style,
                    color: mainColor.dark,
                },
            }}
        />
    );

    return (
        <MuiRadio
            {...props}
            icon={icon}
            checkedIcon={checkedIcon}
            data-testid="radio"
        />
    );
};
